import { put, takeLeading } from 'redux-saga/effects';

import roomPriceTypeApi from 'api/roomPriceType';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_PLACE_OTA_DATA,
  GET_PLACE_OTA_DATA_FAILED,
  GET_PLACE_OTA_DATA_SUCCESS,
  GET_ROOM_PRICE_TYPES,
  GET_ROOM_PRICE_TYPES_FAILED,
  GET_ROOM_PRICE_TYPES_SUCCESS,
  UPDATE_ROOM_PRICE_TYPES,
  UPDATE_ROOM_PRICE_TYPES_FAILED,
  UPDATE_ROOM_PRICE_TYPES_SUCCESS,
} from './actionTypes';

function* getRoomPriceTypes({ payload }) {
  try {
    const response = yield roomPriceTypeApi.getRoomPriceTypes(payload);

    yield put({
      type: GET_ROOM_PRICE_TYPES_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_ROOM_PRICE_TYPES_FAILED,
    });
  }
}

function* getPlaceOtaData({ payload }) {
  try {
    const response = yield roomPriceTypeApi.getPlaceOtaData(payload);

    yield put({
      type: GET_PLACE_OTA_DATA_SUCCESS,
      payload: response.payload,
    });
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: GET_PLACE_OTA_DATA_FAILED,
    });
  }
}

function* updateRoomPriceTypes({ payload }) {
  try {
    yield roomPriceTypeApi.updateRoomPriceTypes(payload);

    yield put({
      type: UPDATE_ROOM_PRICE_TYPES_SUCCESS,
    });

    showSuccess('Cập nhật loại giá thành công');

    if (payload.callback) {
      payload.callback();
    }
  } catch (error) {
    apiErrorHandler(error);

    yield put({
      type: UPDATE_ROOM_PRICE_TYPES_FAILED,
    });
  }
}

export default function* roomPriceTypeSaga() {
  yield takeLeading(GET_PLACE_OTA_DATA, getPlaceOtaData);
  yield takeLeading(GET_ROOM_PRICE_TYPES, getRoomPriceTypes);
  yield takeLeading(UPDATE_ROOM_PRICE_TYPES, updateRoomPriceTypes);
}
